import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab784a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lives" }
const _hoisted_2 = ["disabled"]

import { reactive, watch } from 'vue';
import { handleGameOver } from '@/utils/roundEndHelper';
import { useGameStore, GameStatus, RoundStatus } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';

import BadgeComponent from '@/components/BadgeComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LifeBadge',
  setup(__props) {

const gameStore = useGameStore();
const userStore = useUserStore();

function getLifeStatus() {
  switch (userStore.lives) {
    case 3:
      return 'success';
    case 2:
      return 'warning';
    default:
      return 'error';
  }
}
const scores = reactive({
  current: 0,
  previous: 0
});

watch(
  () => userStore.score,
  (newScore, previousScore) => {
    scores.current = newScore;
    scores.previous = previousScore || 0;
  }
);

watch(
  () => userStore.lives,
  (livesAfter, livesBefore) => {
    if (livesAfter == userStore.initialUserLives) {
      document
        .querySelectorAll(`.lives > *`)
        .forEach((value) => value.classList.remove('lost'));
      return;
    }
    window.setTimeout(
      () =>
        document.querySelector(`.life-${livesBefore}`)?.classList.add('lost'),
      gameStore.roundStatus != RoundStatus.EXPIRED ? 1500 : 0
    );
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BadgeComponent, {
    variant: getLifeStatus()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).lives, (x) => {
          return (_openBlock(), _createElementBlock("span", {
            key: x,
            class: _normalizeClass(`life-${x}`)
          }, " ♥︎ ", 2))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "life-badge__surrender",
        disabled: _unref(gameStore).status !== _unref(GameStatus).InProgress,
        type: "submit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleGameOver)()))
      }, " Surrender ", 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["variant"]))
}
}

})